import { moneyJsConvert } from '@upright/common/utils/currency/money';
import { exchangeRates2019 } from './exchange-rates-2019';

// Fetched on 28.1.2019 from
// https://openexchangerates.org/api/latest.json?app_id=34d13096469f4d4f9862c6a965114be4
// Read more: https://docs.openexchangerates.org/docs/

export function convertToUsd(value: number, currency: string): number {
  // All code but NFRD calculation still use the old default 2019 exchange rates
  return convertToCurrency(value, currency, 'USD');
}

export function convertToCurrency(amount: number, fromCurrency: string, toCurrency: string, year = 2019): number {
  if (!fromCurrency || !toCurrency) {
    throw Error('Undefined currency');
  }
  const fromCurrencyUpper = fromCurrency.toUpperCase();
  const toCurrencyUpper = toCurrency.toUpperCase();
  try {
    return moneyJsConvert(fromCurrencyUpper, toCurrencyUpper, amount, year);
  } catch (e) {
    throw Error(`Unable to convert ${amount} ${fromCurrency} to ${toCurrency}`);
  }
}

export function getCurrencies() {
  return Object.keys(exchangeRates2019.rates);
}

export const supportedCurrencies = Object.keys(exchangeRates2019.rates);

export function isSupportedCurrency(currency: string | undefined) {
  if (!currency) {
    return false;
  }

  return supportedCurrencies.includes(currency);
}
